// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-primary {
  background: rgb(216, 149, 25);
  background: linear-gradient(0deg, rgb(216, 149, 25) 0%, rgb(253, 187, 45) 100%);
}

.grayscale {
  filter: grayscale(1);
}

.danger {
  color: var(--ion-color-danger);
}

:root {
  --ion-font-family: "Poppins";
  --ion-color-primary: #f6a91c;
  --ion-color-primary-rgb: 246, 169, 28;
  --ion-color-primary-contrast: #000000;
  --ion-color-primary-contrast-rgb: 0, 0, 0;
  --ion-color-primary-shade: #d89519;
  --ion-color-primary-tint: #f7b233;
  --ion-color-secondary: #000;
  --ion-color-secondary-rgb: 0, 0, 0;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #000000;
  --ion-color-secondary-tint: #1a1a1a;
  --ion-color-tertiary: #fff;
  --ion-color-tertiary-rgb: 255, 255, 255;
  --ion-color-tertiary-contrast: #000000;
  --ion-color-tertiary-contrast-rgb: 0, 0, 0;
  --ion-color-tertiary-shade: #e0e0e0;
  --ion-color-tertiary-tint: #ffffff;
  --ion-color-success: #198754;
  --ion-color-success-rgb: 25, 135, 84;
  --ion-color-success-contrast: #000000;
  --ion-color-success-contrast-rgb: 0, 0, 0;
  --ion-color-success-shade: #1b6d47;
  --ion-color-success-tint: #12b86b;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb: 255, 196, 9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb: 235, 68, 90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb: 146, 148, 156;
  --ion-color-medium-contrast: #000000;
  --ion-color-medium-contrast-rgb: 0, 0, 0;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #fbfbfb;
  --ion-color-light-rgb: 245, 245, 245;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #d8d8d8;
  --ion-color-light-tint: #f6f6f6;
}

#app-content ion-router-outlet {
  max-width: 1500px;
  margin: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/variables.scss","webpack://./src/app/core/app.component.scss"],"names":[],"mappings":"AAIA;EACE,6BAAA;EACA,+EAAA;ACHF;;ADMA;EACE,oBAAA;ACHF;;ADMA;EACE,8BAAA;ACHF;;ADMA;EACE,4BAAA;EAMA,4BAAA;EACA,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,kCAAA;EACA,uCAAA;EACA,iDAAA;EACA,oCAAA;EACA,mCAAA;EAEA,0BAAA;EACA,uCAAA;EACA,sCAAA;EACA,0CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;ACfF;;AA5DA;EACE,iBAAA;EACA,uBAAA;AA+DF","sourcesContent":["$bg-color: var(--ion-background-color) !important;\n$dark-gray: #333;\n$medium-gray: rgb(153, 153, 153);\n\n.gradient-primary {\n  background: rgb(216, 149, 25);\n  background: linear-gradient(0deg, rgba(216, 149, 25, 1) 0%, rgba(253, 187, 45, 1) 100%);\n}\n\n.grayscale {\n  filter: grayscale(1);\n}\n\n.danger {\n  color: var(--ion-color-danger);\n}\n\n:root {\n  --ion-font-family: 'Poppins';\n  $font-family-base: 'Poppins';\n  $font-family-ios-base: 'Poppins';\n  $font-family-md-base: 'Poppins';\n  $font-family-wp-base: 'Poppins';\n\n  --ion-color-primary: #f6a91c;\n  --ion-color-primary-rgb: 246, 169, 28;\n  --ion-color-primary-contrast: #000000;\n  --ion-color-primary-contrast-rgb: 0, 0, 0;\n  --ion-color-primary-shade: #d89519;\n  --ion-color-primary-tint: #f7b233;\n\n  --ion-color-secondary: #000;\n  --ion-color-secondary-rgb: 0, 0, 0;\n  --ion-color-secondary-contrast: #ffffff;\n  --ion-color-secondary-contrast-rgb: 255, 255, 255;\n  --ion-color-secondary-shade: #000000;\n  --ion-color-secondary-tint: #1a1a1a;\n\n  --ion-color-tertiary: #fff;\n  --ion-color-tertiary-rgb: 255, 255, 255;\n  --ion-color-tertiary-contrast: #000000;\n  --ion-color-tertiary-contrast-rgb: 0, 0, 0;\n  --ion-color-tertiary-shade: #e0e0e0;\n  --ion-color-tertiary-tint: #ffffff;\n\n  --ion-color-success: #198754;\n  --ion-color-success-rgb: 25, 135, 84;\n  --ion-color-success-contrast: #000000;\n  --ion-color-success-contrast-rgb: 0, 0, 0;\n  --ion-color-success-shade: #1b6d47;\n  --ion-color-success-tint: #12b86b;\n\n  --ion-color-warning: #ffc409;\n  --ion-color-warning-rgb: 255, 196, 9;\n  --ion-color-warning-contrast: #000000;\n  --ion-color-warning-contrast-rgb: 0, 0, 0;\n  --ion-color-warning-shade: #e0ac08;\n  --ion-color-warning-tint: #ffca22;\n\n  --ion-color-danger: #eb445a;\n  --ion-color-danger-rgb: 235, 68, 90;\n  --ion-color-danger-contrast: #ffffff;\n  --ion-color-danger-contrast-rgb: 255, 255, 255;\n  --ion-color-danger-shade: #cf3c4f;\n  --ion-color-danger-tint: #ed576b;\n\n  --ion-color-medium: #92949c;\n  --ion-color-medium-rgb: 146, 148, 156;\n  --ion-color-medium-contrast: #000000;\n  --ion-color-medium-contrast-rgb: 0, 0, 0;\n  --ion-color-medium-shade: #808289;\n  --ion-color-medium-tint: #9d9fa6;\n\n  --ion-color-light: #fbfbfb;\n  --ion-color-light-rgb: 245, 245, 245;\n  --ion-color-light-contrast: #000000;\n  --ion-color-light-contrast-rgb: 0, 0, 0;\n  --ion-color-light-shade: #d8d8d8;\n  --ion-color-light-tint: #f6f6f6;\n}\n\n// MEDIA QUERIES\n$phone: 576px;\n$tablet: 768px;\n$laptop: 992px;\n$desktop: 1200px;","@import '../../theme/variables.scss';\n\n\n#app-content ion-router-outlet {\n  max-width: 1500px;\n  margin: auto !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
